import React from "react";
import styles from "./SyncSchedulePanel.module.scss";

interface ISyncSchedulePanelHeaderProps {
  requiresEgress: boolean;
  dpmsTypeName: string;
}

const SyncSchedulePanelHeader: React.FC<ISyncSchedulePanelHeaderProps> = ({
  requiresEgress,
  dpmsTypeName
}) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerTitle}>
        {requiresEgress ? 'Ingress and Egress Customer' : 'Ingress Only Customer'} - {dpmsTypeName}
      </div>
      <div className={styles.headerSubtext}>
        Configure sync schedules by clicking entity types to enable or disable them for syncing.
        {requiresEgress && (
          <span className={styles.headerSubtextItalic}> Dependency conflicts are shown for egress customers.</span>
        )}
      </div>
    </div>
  );
};

export default SyncSchedulePanelHeader;
